<template>
    <div v-if="!error" class="detail">
        <div class="detail-hd">
            <img src="@/assets/vipCoach/v2/icon_gzfcg.png">
            <h4>恭喜您，支付成功！</h4>
            <div class="price">{{detail.orderMoney}}</div>
        </div>
        <div class="detail-box">
            <div class="detail-group">
                <label>下单手机号</label>
                <div class="detail-group__info">{{detail.userMobile}}</div>
            </div>
            <div class="detail-group">
                <label>商品</label>
                <div class="detail-group__info">{{detail.productName}}</div>
            </div>
            <div class="detail-group">
                <label>交易时间</label>
                <div class="detail-group__info">{{detail.transationTime}}</div>
            </div>
            <div class="detail-group">
                <label>支付方式</label>
                <div class="detail-group__info">{{detail.payType}}</div>
            </div>
            <div class="detail-group">
                <label>交易单号</label>
                <div class="detail-group__info">{{detail.transationOrderNo}}</div>
            </div>
        </div>
        <div class="tips">
            <p>温馨提示</p>
            <p>1.购买成功后请使用付款手机号登录斑斑驾道定制版APP查看商品并使用相关权限；</p>
            <p>2. 若有疑问请联系拨打客服电话400-603-9603。</p>
        </div>
        <div class="jump" @click="toApp">前往APP查看使用>></div>
    </div>
    <div v-else class="error">
        <p>系统监测到您支付中可能出现以下异常</p>
        <p>情况一：微信支付失败</p>
        <p>情况二：微信支付成功，商品权限未开通</p>
        <h4>解决方案</h4>
        <p>情况一：重新下单发起支付即可</p>
        <p>情况二：您可在工作日9:00-18:00拨打客服电话<a href="tel:400-603-9603">400-603-9603</a>说明情况，提供下单手机号，我们将为您开通对应的商品权限</p>
        <div>给您造成不便深表歉意,感谢您的理解和支持。</div>
        <div class="jump">
            <a href="tel:400-603-9603">联系客服>></a>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant'
import { linkApp } from '../../utils'
import { getPaySuccess } from '../../api'

export default {
    name: 'vipCoachGoodsDetail',
    data () {
        return {
            error: false,
            detail: {}
        }
    },
    methods: {
        // 查询详情
        getDetail () {
            const loading = Toast.loading({ duration: 3000, forbidClick: true })
            const { goodsCode, orderId } = this.$route.query
            getPaySuccess({
                goodsCode,
                orderId
            }).then(res => {
                loading.clear()
                if (res.status) {
                    this.detail = res.result
                } else {
                    document.title = '支付异常'
                    this.error = true
                }
            })
        },
        toApp () {
            linkApp()
        }
    },
    mounted () {
        this.getDetail()
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
.detail{
    padding: 15px;
    color:#333;
    font-size: 14px;
    line-height: 1;
    &-hd{
        text-align: center;
        img {
            width: 120px;
        }
        h4{
            margin-top: 14px;
            font-weight: 600;
            font-size: 20px;
        }
        .price{
            margin-top: 20px;
            font-size: 42px;
            &::before{
                content: '¥';
                margin-top: 4px;
                margin-right: 8px;
                display: inline-block;
                vertical-align: top;
                font-size: 30px;
            }
        }
    }
    &-box{
        margin-top: 40px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
    }
    &-group{
        display: flex;
        font-size: 15px;
        align-items: center;
        &+&{
            margin-top: 15px;
        }
        div{
            flex: 1;
            text-align: right;
        }
    }
    .tips{
        margin-top: 20px;
        color:#666;
        font-size: 15px;
        line-height: 24px;
    }
}
.jump{
    margin-top: 30px;
    color: #53CB85;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
}
.error{
    padding:20px;
    color:#333;
    font-size: 14px;
    p{
        margin-bottom: 5px;
        line-height: 24px;
    }
    a{
        color: #53CB85;
    }
    h4{
        margin-top: 20px;
        margin-bottom: 10px;
    }
    div{
        margin-top: 20px;
        margin-bottom: 30px;
    }
}
</style>
